/* eslint-disable import/order */
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { polarisShareViewRoute } from '@jira/router-routes__polaris-routes/src/polarisShareViewRoute.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { polarisShareViewEntryPoint } from './ui/share-view/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const polarisShareViewRouteEntry: Route = createEntry(polarisShareViewRoute, () => ({
	isStrictModeEnabled: false,
	group: 'polaris',
	ufoName: 'jpd.shared-view',

	layout: chromelessLayout,

	resources: [...jiraSpaResources()],

	entryPoint() {
		return polarisShareViewEntryPoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
		cspOverride: {
			frameAncestors: '*',
		},
	},
}));
